import { userApi } from './index';
import { config } from '../config';
import { TypeOfSocials } from '../../../models/Socials';
import { SocialsProps } from './authorization';

export const socialsApi = userApi.injectEndpoints({
  endpoints: (build) => ({
    unlink: build.mutation<{ success: boolean }, TypeOfSocials>({
      query: (network) => ({
        url: config.SOCIALS.UNLINK,
        method: 'POST',
        body: {
          network,
        },
      }),
      invalidatesTags: ['UserInfo'],
    }),
    connect: build.mutation<{ success: boolean }, SocialsProps>({
      query: ({ type, email, socialUserId, surname, name, accessToken }) => ({
        url: config.SOCIALS.CONNECT(type),
        method: 'POST',
        body: {
          social_user_id: socialUserId,
          access_token: accessToken,
          email,
          surname,
          name,
        },
      }),
      invalidatesTags: ['UserInfo'],
    }),
  }),
});
